import React from "react";

import styles from "./index.module.less";

import Header from './Header'
import Introduction from "./Introduction";
import Vacancies from "./Vacancies";

const Careers: React.FC = () => {

  return (
    <div className={styles.careersContainer}>
      <Header />
      <Introduction />
      <Vacancies />
    </div>
  );
};

export default Careers;
